<template>
    <div v-if="type === 'rollingDots'" v-bind:class="$style.rollingDots">
        <div v-bind:class="$style.firstDot" v-bind:style="{ 'background-color': color }"></div>
        <div v-bind:class="$style.secondDot" v-bind:style="{ 'background-color': color }"></div>
    </div>
</template>

<script>
    export default {
        /**
         * Define the properties passed into the component from the parent.
         *
         * @link https://vuejs.org/v2/guide/components.html#Props
         */
        props: {
            type: {
                type: String,
                default: 'rollingDots',
            },
            color: {
                type: String,
                default: '#5f5f5f',
            },
        },
    };
</script>

<style lang="scss" module>
    .rollingDots {
        @apply relative text-center mx-auto;
        width: 3.1rem;
        height: 3.1rem;
        animation: sk-rotate 1.5s infinite linear;
    }

    .firstDot,
    .secondDot {
        @apply absolute top-0 inline-block rounded-full;
        width: 60%;
        height: 60%;
        animation: sk-bounce 1.5s infinite ease-in-out;
    }

    .secondDot {
        @apply inset-auto bottom-0;
        animation-delay: -.75s;
    }

    @keyframes sk-rotate {
        100% {
            transform: rotate(360deg);
        }
    }
    @keyframes sk-bounce {
        0%,
        100% {
            transform: scale(0);
        }

        50% {
            transform: scale(1);
        }
    }
</style>
